// @ts-nocheck
/**
 * Calculate dynamic height for use on components with drawer
 *
 * Set prop fixedGridWidth to true if you want to component have horizontal scroll instead of resizing with drawer
 */
import * as _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import CookieUtil from '../../../utility/CookieUtil';
import {
  ActionType,
  ChildrenType,
  Dispatcher,
  OperationType,
  Position,
  RequestDataBase
} from '../../../index';
import MaskCSS from '../mask/Mask';
import { DispatcherPopupWindow } from '../../services/Types';
import Translatable from '../../services/i18n/Translatable';
import LocalCache from '../../../utility/LocalCache';
import AuthService from '../../authentication/services/AuthService';
import {
  getNodesFromContainerFromType,
  getNodesFromContainerFromTypes
} from '../../../utility/Util';
import { SORT_GROUP_ITEMS_DATA } from './Types';

// tsc cant create d.ts files from exported functions containing protected/private members
// https://github.com/microsoft/TypeScript/issues/30355
// https://github.com/microsoft/TypeScript/issues/36060
// https://github.com/microsoft/TypeScript/issues/17293#issuecomment-522491710

type MODULE_PROPS = {
  moduleId?: string
  t?: Function
  topLevelComponent?: boolean
}

function withModule(pure: boolean = false) {
  return class Component<P = {}, S = {}> extends (!pure ? React.Component : React.PureComponent)<P & MODULE_PROPS, S> {
    /**
     * @property {Object} allUploadFlowState Object that contains all upload process states
     */
    public allUploadFlowState: any = {};
    dispatcherPopupWindowData: DispatcherPopupWindow = null;
    moduleId: string | null = null;
    moduleName: string = '';
    namespacePrefix: string = '';
    static history: any; // history object from withRouter
    isModuleMounted: boolean = false;
    popupWindowChildrenUpdated: boolean = false;

    /**
     * Sets state sync by Promise
     * @param state
     */
    setStateSync = (state: any) => new Promise(resolve =>
      this.setState(state, resolve)
    )

    /**
     * Method that will be called in order to refreshData for module component.
     * Override in module to call dispatcher action with proper data.
     */
    onRefreshData?(requestCfg?: RequestDataBase, additionalData?: object): void;

    appModuleConfig = {
      operations: {}
    };

    state: any = {
      maskModule: null,
      popupWindowChildren: null,
      uploadFlowState: {}
    };

    constructor(props: any) {
      super(props);
      const me = this;
      let { moduleName = me.constructor.name, moduleId = null, dispatcherUpdateStates = null } = props;
      me.moduleName = moduleName;
      me.moduleId = moduleId;

      Dispatcher.registerModule(me.moduleName, me); // register module to dispatcher
      if (!_.isEmpty(dispatcherUpdateStates)) {
        Dispatcher.registerUpdateStateModule(me.moduleName, dispatcherUpdateStates);
      }
      if (props.actions) {
        Dispatcher.registerActions(props.actions, me.moduleName); // register all actions at once on dispatcher
      }
      if (props.topLevelComponent) {
        Dispatcher.topLevelComponentName = me.moduleName;
      }

      if (props.history && !Component.history) {
        Component.history = props.history;
        if (Component.history.listen) {
          Component.history.listen(me.beforeRouteChange);
        }
        Dispatcher.redirectTo = me.redirectTo;
      }

      // Set Dispatcher Properties To Popup Window Dispatcher
      me.dispatcherPopupWindowData = _.get(window, 'dispatcherPopupWindowData');
      if (me.dispatcherPopupWindowData && _.isObject(me.dispatcherPopupWindowData) && _.get(me.dispatcherPopupWindowData, 'renderTo') === me.moduleName) {
        _.assign(Dispatcher.appOperationData, _.get(me.dispatcherPopupWindowData, 'operation'));
        _.assign(Dispatcher.appAllPersistentData, _.get(me.dispatcherPopupWindowData, 'persistent'));
      }
    }

    /**
     * Returns moduleId
     */
    getModuleId = () => this.moduleId

    getModuleName = () => this.moduleName

    emptyFn = () => {}

    /**
     * Returns is all upload process ended
     */
    public isAllUploadEnd = () => {
      const { step, uploadGroupId } = this.state.uploadFlowState;
      let isEnd = true;
      if (uploadGroupId && step) {
        this.allUploadFlowState[uploadGroupId] = step;
        for (let prop in this.allUploadFlowState) {
          if (this.allUploadFlowState.hasOwnProperty(prop)) {
            isEnd = this.allUploadFlowState[prop] === 'end';
            if (!isEnd) {
              break;
            }
          }
        }
      }
      return isEnd;
    };

    /**
     * Handles before route changes.
     */
    beforeRouteChange = (history) => {
      this.dispatch('checkCookiesBeforeRouteChanges', {
        pos: Position.start
      });

      if (history.state?.route && !AuthService.isAuthenticatedAsync()) {
        AuthService.isAuthenticated().then((authenticated) => {
          if (!authenticated) {
            // writes last route to LocalStore to remember it after auth redirects
            LocalCache.setItem('route', history.state.route);
          }
        });
      }

      // this.dispatch('ShowUploadFileProgresses', {
      //   dispatcherId: ASYNC_UPLOAD_DISPATCHER_NAME
      // });
    };

    /**
     * Catch any component errors
     * @param {any} error
     */
    componentDidCatch(error) {
      Dispatcher.errorTrap.trap(error);
    }

    /**
     * Redirect Method
     * @param path
     * @param forceRefresh
     * @param cookieConsent
     */
    public redirectTo(path: string, forceRefresh: boolean = false, cookieConsent: boolean = false): void {
      if (Component.history) {
        if (cookieConsent) {
          let url: string | null = CookieUtil.getConsentUrl();
          if (url) {
            window.location.replace(url + window.location.href);
          } else {
            // <debug>
            console.warn('In order to use cookies, consent url must be provided trough properties.config file in section' +
              ' CONSENT or passed via dispatcher operation type OperationType.cookie with method name `consentUrl`.');
            // </debug>
          }
        }
        if (forceRefresh) {
          // use with care, this will trigger all actions on the current path
          // case: trigger all after token refresh to fetch latest state
          window.location.replace(path);
        } else {
          if (path !== window.location.pathname) {
            Component.history.push({
              pathname: path
            }, {
              previous: window.location.pathname
            });
          }
        }
      }
    }

    /**
     * Entry point for dispatching actions from dispatcher modules.
     * @param {string} actionName Name of action that is dispatching.
     * @param {ActionType/Position/String} actionType Action configuration.
     * @param {any} data Data that will be added to dispatchers `appOperationData` before action is executed.
     * @param {string} methodName
     * @param {any} specialData
     */
    dispatch(actionName: string, actionType?: ActionType | Position | string, data?: any, methodName?: string, specialData?: any): void {
      if (this.dispatcherPopupWindowData) {
        const { dispatcherId } = this.dispatcherPopupWindowData;
        if (actionType) {
          if (_.isString(actionType)) {
            actionType = {
              dispatcherId,
              pos: Position.end
            };
          } else {
            actionType = {
              ...actionType,
              dispatcherId
            };
          }
        }
      }
      Dispatcher.dispatchFromModule(this.moduleName, actionName, actionType, data, methodName, specialData);
    }

    // noinspection JSMethodCanBeStatic
    getSafe(obj: any, path: string): any {
      return _.get(obj, path);
    }

    /**
     * Method that is used only trough dispatcher operation type `OperationType.generateOperation`.
     * @param {any} arg
     */
    dispatchNativeMethod(arg: any): any {
      let { fn, getValue, scope = this } = arg;
      delete arg.fn;
      delete arg.getValue;
      delete arg.scope;
      delete arg.dispatcherId;
      let value = scope;

      let args = [];
      for (const prop in arg) {
        if (arg.hasOwnProperty(prop) && prop !== 'dispatcherId') {
          args.push(arg[prop]);
        }
      }
      if (fn && scope[fn]) {
        value = scope[fn].apply(scope, args);
      }
      if (typeof getValue === 'string') {
        value = this.getSafe(value, getValue);
      }
      return value;
    }

    /**
     * Check is component rendered in dom.
     */
    isVisible = (): boolean => {
      const { hidden = false } = this.getDomNode() || {};
      return !hidden;
    };

    /**
     * Check is component displayed (visible) in dom.
     */
    isDisplayed = (): boolean => {
      const domNode = this.getDomNode();
      let displayed = false;
      if (domNode?.getBoundingClientRect) {
        const rect = domNode?.getBoundingClientRect();
        displayed = rect.height > 0 && rect.width > 0;
      }
      return displayed;
    };

    /**
     * Manipulates with collapsed property trough dispatcher. Mask won't be shown on components that are collapsed.
     */
    getCollapsed(): boolean {
      return false;
    }

    /**
     * getDomNode method is created to enable debugging dispatcher MaskModule Operation.
     * @param {any} scope By default returns dom node of module scope or scope can be passed.
     */
    getDomNode(scope: any = this): HTMLElement {
      try {
        return ReactDOM.findDOMNode(scope) as HTMLElement;
      } catch (e) {
        return null;
      }
    }

    /**
     * Mask method is called through dispatcher when operation type is `OperationType.maskModule`.
     * @param {string} message Message that will be shown on top of mask. If message is not provided, it will show default message.
     * @param {string} className - Custom CSS classes to be applied to the mask.
     * @param {string} maskType - The type of mask to be applied, e.g., `MaskType.LIGHT_SQUARE`, `MaskType.SPLASH`, etc.
     */
    public mask = (message: string, className: string, maskType: string): void => {
      if (this.translate) {
        message = this.translate(message);
      }
      const selfDom = this.getDomNode();
      if (selfDom) {
        const { offsetTop, offsetLeft, offsetWidth, offsetHeight } = selfDom;

        this.setState({
          maskModule: {
            message: message,
            top: offsetTop,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight,
            className: className,
            maskType: maskType
          }
        });
        Dispatcher.registerUpdateStateModule(this.moduleName, {
          unmaskAllModule: {}
        });
      }
    }

    /**
     * Unmask method is called trough dispatcher when operation type is `OperationType.unmaskModule`.
     */
    unmask(): void {
      this.setState({ maskModule: null });
      Dispatcher.unregisterUpdateStateModule(this.moduleName);
    }

    /**
     * Translates text that is localized in this module or in some of base modules
     * @param key
     * @param options
     * @param moduleName
     * @param scope
     */
    translate = (key: string, options?: any, moduleName = this.moduleName, scope = this) => {
      let translatedText = Translatable.translate(key, moduleName, this.namespacePrefix, options);
      if (translatedText === key) {
        scope = Object.getPrototypeOf(scope);
        if (scope) {
          moduleName = scope.constructor.name;
          if (moduleName !== 'Component') {
            translatedText = this.translate(key, options, moduleName, scope);
          }
        }
      }
      return translatedText;
    }

    /**
     *
     * @param field
     * @param options
     */
    translateErrorMessage = (field: any, options?: any) => Translatable.translateErrorMessage(field, this.moduleName, this.namespacePrefix, options);

    /**
     *
     * @param key
     * @param options
     * @param namespace
     */
    translateByNamespace = (key: string, options = {}, namespace: string = 'common') => Translatable.translateByNamespace(key, options, namespace);

    /**
     *
     * @param namespace
     * @param key
     * @param options
     * @param moduleName
     * @param namespacePrefix
     */
    translateByModuleName = (namespace: string, key: string, options = {}, moduleName: string, namespacePrefix: string = '') => Translatable.translateByModuleName(namespace, key, options, moduleName ? moduleName : this.moduleName, namespacePrefix ? namespacePrefix : this.namespacePrefix);

    /**
     * Render mask.
     */
    public renderMask(): any {
      let { maskModule: mask = null } = this.state;
      if (mask) {
        const { top, left, height, width, message, maskType, className } = mask;
        mask = (
          <MaskCSS
            // <debug>
            maskForModuleId={this.moduleId}
            // </debug>
            top={top}
            left={left}
            height={height}
            width={width}
            message={message}
            maskType={maskType}
            className={className}
            endMaskMassage={this.translate('loadingCompleted')}
          />);
      }
      return mask;
    }

    /**
     * Used for clean up. Unregister module from dispatcher.
     */
    componentWillUnmount(): void {
      this.isModuleMounted = false;
      Dispatcher.unregisterModule(this.moduleName, this);
      if (this.props.dispatcherUpdateStates) {
        Dispatcher.unregisterUpdateStateModule(this.moduleName);
      }
    }

    /**
     * Used for registration module as mounted in dispatcher. Used in conjunction with `waitForModule` operation property.
     * Operation will wait for module to mount if `waitForModule` is passed.
     */
    componentDidMount(): void {
      this.isModuleMounted = true;
      Dispatcher.registerModuleAsMounted(this.moduleName);
      this.moduleDidMount();
      if (this.dispatcherPopupWindowData && this.dispatcherPopupWindowData.renderTo === this.moduleName) {
        const { actionName, data } = this.dispatcherPopupWindowData;
        Dispatcher.dispatch(
          actionName,
          {
            executeOnlyOperationType: OperationType.popupWindow,
            pos: Position.end
          },
          {
            ...data,
            redirectPopupWindow: true
          }
        );
      }
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
      if (this.state.popupWindowChildren && !this.popupWindowChildrenUpdated) {
        this.popupWindowChildrenUpdated = true;
        setTimeout(() => {
          this.setFocusToFirstTab(window.document.body);
        }, 1);
      }
      this.moduleDidUpdate(prevProps, prevState, snapshot);
    }

    /**
     * Called when module is updated.
     */
    public moduleDidUpdate = (prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) => {

    }

    /**
     * Called when module is mounted.
     */
    public moduleDidMount() {
    }

    /**
     * Sets content of window after repeated executing popupWindow operation in order to get instance of content
     * component from new browser
     * @param {ChildrenType[]} children
     */
    setWindowPopupChildren = (children: ChildrenType[]) => {
      this.setState({
        popupWindowChildren: children
      });
    };

    /**
     * Sets listened and changed variables to same name state properties
     * @param {String} prop
     * @param {*} value
     */
    setDispatcherUpdateState = (prop, value) => {
      const { mappingName = prop } = this.props.dispatcherUpdateStates ? this.props.dispatcherUpdateStates[prop] : {};
      if (mappingName === 'unmaskAllModule') {
        if (value) {
          this.unmask();
        }
      } else {
        this.setState({
          [mappingName]: value
        });
      }
    }

    /**
     * Sets default focus to module (There can be input fields or button if there is not input field)
     * @param {HTMLElement} node
     */
    setFocusToFirstInputFieldOrButton = (node: any) => {
      const inputFields = getNodesFromContainerFromType(node, 'input');
      let focusNode;
      if (inputFields.length) {
        focusNode = inputFields[0];
      } else {
        const buttons = getNodesFromContainerFromType(node, 'button');
        if (buttons.length) {
          focusNode = buttons[0];
        } else {
          // @ts-ignore
          focusNode = node;
        }
      }
      if (focusNode) {
        focusNode.focus();
      }
    };

    /**
     * Sets default focus to module into first tag with attribute 'tabindex'
     * @param {HTMLElement} node
     */
    setFocusToFirstTab = (node: any) => {
      const tabs = getNodesFromContainerFromTypes(node, [], [{
        name: 'tabindex'
      }]);
      if (tabs.length) {
        tabs[0].focus();
      }
    }

    /**
     * Sorts the data object alphabetically
     * @param {SORT_GROUP_ITEMS_DATA} data is the object which needs to be sorted
     * @param {string} targetItem
     * @param {string} moduleName
     * @param {string} nameSpace
     * @param {any} options
     * Takes values which are arrays and doing localeCompare to items in it
     */
    public sortGroupItems = (data: SORT_GROUP_ITEMS_DATA, targetItem: string, moduleName: string, nameSpace: string = 'translation', options:any = {}):SORT_GROUP_ITEMS_DATA => {
      let sortedData: SORT_GROUP_ITEMS_DATA = {};

      for (const key in data) {
        if (data[key]) {
          // Sort the array of values alphabetically
          let sortedValues = data[key].sort((prev: any, curr: any) => {
            let permissionOne: string = this.translateByModuleName(nameSpace, prev[targetItem], options, moduleName);
            let permissionTwo: string = this.translateByModuleName(nameSpace, curr[targetItem], options, moduleName);
            return permissionOne.localeCompare(permissionTwo);
          });
          // Add the sorted values to the sorted object with the same key
          sortedData[key] = sortedValues;
        }
      }

      return sortedData;
    };

    /**
     * Rendering children components to body
     * @param {ChildrenType} children
     */
    renderChildren(children: ChildrenType) {
      // @ts-ignore
      children = children.map((child: ChildrenType) => React.createElement(child.render, child.props));
      return React.Children.toArray(children);
    }

    /**
     * Renders the body depending on type of window (base or popup)
     */
    componentRenderBody = () => {
      let rend = null;
      if (this.dispatcherPopupWindowData) {
        const { renderTo } = this.dispatcherPopupWindowData;
        if (renderTo === this.moduleName) {
          if (this.state.popupWindowChildren) {
            rend = this.renderChildren(this.state.popupWindowChildren);
          }
        } else {
          rend = this.renderBody();
        }
      } else {
        rend = this.renderBody();
      }
      return rend;
    };

    /**
     * Gets request object parameters for `refreshData`.
     * @param requestCfg
     */
    getRefreshData = (requestCfg: RequestDataBase) => {
      let { requestCfg: config = {} } = this.props;
      if (!_.isEmpty(requestCfg)) {
        _.merge(config, requestCfg);
      }
      return config;
    };

    /**
     * Calling dispatcher action that will refresh data for called module.
     * In order to work there must be defined `onRefreshData` method within created module.
     * @param requestCfg
     * @param additionalData
     */
    refreshData = (requestCfg?: RequestDataBase, additionalData: object = {}) => {
      if (_.isFunction(this.onRefreshData) && _.isObject(requestCfg)) {
        this.onRefreshData(this.getRefreshData(requestCfg), additionalData);
      }
    };

    /**
     * Render component. By default returns React.Fragment element.
     */
    renderBody(): any {
      return <></>;
    }

    /**
     * Render body of component and mask for that component.
     */
    render(): any {
      return (
        <>
          {this.componentRenderBody()}
          {this.renderMask()}
        </>
      );
    }
  };
}

export default withModule;
